import { flow } from 'mobx';

import BaseStore from './BaseStore';
import AnnonceApi from '../api/annonce_api';

class AnnonceStore extends BaseStore {
  postAnswer = flow(
    function* ({
      id, answer, setErrors, setStatus, setSubmitting,
    }) {
      this.isLoading = true;

      try {
        yield AnnonceApi.postAnswer(id, answer);
        setStatus({ success: true });
      } catch (e) {
        if (e.response?.data?.errorMessages?.message) {
          const { message } = e.response.data.errorMessages;
          Object.keys(message).forEach((errorField) => {
            const errorMessage = message[errorField];
            if (Array.isArray(errorMessage)) {
              message[errorField] = errorMessage.join(',');
            }
          });

          setErrors(message);
        } else {
          // eslint-disable-next-line no-console
          console.error(e);
          setStatus({ success: false });
        }
        setSubmitting(false);
      }
    },
  );
}

export default new AnnonceStore();
